<template>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.0835 2.91663H6.66683C8.50779 2.91663 10.0002 4.409 10.0002 6.24996V17.5C10.0002 16.1193 8.88087 15 7.50016 15H2.0835V2.91663Z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
        <path d="M17.9167 2.91663H13.3333C11.4924 2.91663 10 4.409 10 6.24996V17.5C10 16.1193 11.1193 15 12.5 15H17.9167V2.91663Z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
    </svg>
</template>